<div class="ap-page tw-min-h-screen tw-w-full tw-flex tw-justify-center tw-items-start max-md:tw-py-[30px] tablet:tw-py-[60px] tw-px-[16px]" [class.ap-page--error]="loadError" data-variant="premium">

  <!-- ============ Loader ============ -->
  <div *ngIf="isLoadingDetails" class="ap-loader-overlay" aria-live="polite" aria-busy="true">
    <div class="ap-loader-backdrop"></div>

    <div class="ap-loader-content" data-variant="orbit">
      <div class="ap-orbit">
        <div class="ap-orbit-ring ap-orbit-ring--outer"></div>
        <div class="ap-orbit-ring ap-orbit-ring--mid"></div>
        <div class="ap-orbit-track ap-orbit-track--1"><span class="ap-orbit-dot"></span></div>
        <div class="ap-orbit-track ap-orbit-track--2"><span class="ap-orbit-dot ap-orbit-dot--green"></span></div>
        <div class="ap-orbit-track ap-orbit-track--3"><span class="ap-orbit-dot ap-orbit-dot--gold"></span></div>
        <div class="ap-orbit-core"><span class="ap-orbit-core-symbol">$</span></div>
      </div>

      <div class="ap-loader-text">
        <h2 class="ap-loader-title">
          We are fetching your details<span class="ap-loader-dots"><i></i><i></i><i></i></span>
        </h2>
        <p class="ap-loader-subtitle">Securely preparing your payment session</p>
      </div>

      <div class="ap-loader-progress" aria-hidden="true">
        <span class="ap-loader-progress-fill"></span>
      </div>

      <div class="ap-loader-secure">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 2L4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z" stroke="#106B8E" stroke-width="2" stroke-linejoin="round" fill="none"/>
          <path d="M9 12l2 2 4-4" stroke="#106B8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoadingDetails" class="ap-shell tw-w-full tw-max-w-[820px] tw-flex tw-flex-col tw-items-center">

      <header class="ap-hero" *ngIf="!loadError && !isPaymentComplete">
        <h1 class="ap-hero-title">
          <span *ngIf="!isPaymentComplete">Complete Your Payment</span>
          <span *ngIf="isPaymentComplete">Payment Successful</span>
        </h1>
        <p class="ap-hero-subtitle" *ngIf="!isPaymentComplete && !loadError">
          Congratulations on your approved application. Just one final step to finalize your registration.
        </p>
        <p class="ap-hero-subtitle" *ngIf="isPaymentComplete">
          Your registration has been finalized. A confirmation has been sent to your email.
        </p>

        <ol *ngIf="!isPaymentComplete && !loadError" class="ap-steps" aria-label="Checkout progress">
          <li class="ap-step ap-step--done">
            <span class="ap-step-dot">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="ap-step-label">Application</span>
          </li>
          <li class="ap-step-line ap-step-line--done" aria-hidden="true"></li>
          <li class="ap-step ap-step--done">
            <span class="ap-step-dot">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="ap-step-label">Approved</span>
          </li>
          <li class="ap-step-line ap-step-line--active" aria-hidden="true"></li>
          <li class="ap-step ap-step--active">
            <span class="ap-step-dot"></span>
            <span class="ap-step-label">Payment</span>
          </li>
        </ol>
      </header>

      <!-- Error / Deactivated -->
      <ng-container *ngIf="loadError">
        <div class="ap-state-card ap-deactivated">
          <div class="ap-deactivated-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18.84 12.25l1.72-1.71a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"/>
              <path d="M5.17 11.75l-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"/>
              <line x1="8" y1="2" x2="8" y2="5"/>
              <line x1="2" y1="8" x2="5" y2="8"/>
              <line x1="16" y1="19" x2="16" y2="22"/>
              <line x1="19" y1="16" x2="22" y2="16"/>
            </svg>
          </div>
          <h2 class="ap-state-title">This Payment Has Been Deactivated!</h2>
          <p class="ap-state-message">
            This payment portal is no longer accessible.<br />
            If you have any questions please contact the Campaign Organizers.
          </p>
          <div class="ap-trust-poweredby">
            Powered by
            <i-icon name="see-my-legacy" class="tw-h-[30px] tw-w-[130px]"></i-icon>
          </div>
        </div>
      </ng-container>

      <!-- Success -->
      <ng-container *ngIf="isPaymentComplete">
        <div class="ap-state-card ap-state-card--success tw-mt-[100px]">
          <div class="ap-success-icon" aria-hidden="true">
            <span class="ap-success-ring ap-success-ring--1"></span>
            <span class="ap-success-ring ap-success-ring--2"></span>
            <span class="ap-success-ring ap-success-ring--3"></span>
            <svg class="ap-success-check" xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88" fill="none">
              <circle class="ap-success-check-circle" cx="44" cy="44" r="40" stroke="#5FB173" stroke-width="3" fill="rgba(95,177,115,0.08)"/>
              <path class="ap-success-check-mark" d="M28 46 L40 58 L62 34" stroke="#30997A" stroke-width="5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="ap-state-title ap-state-title--success">Your Payment is Completed!</h2>
          <p class="ap-state-message">
            Thank you for submitting your payment. <br>
            If you have any questions please contact the campaign organizers.
          </p>
          <div class="ap-trust-poweredby">
          Powered by
          <i-icon name="see-my-legacy" class="tw-h-[30px] tw-w-[130px]"></i-icon>
        </div>
        </div> 
      </ng-container>

      <!-- Main checkout card -->
      <ng-container *ngIf="!loadError && !isPaymentComplete && details">
        <div class="ap-checkout">

          <section class="ap-summary max-md:!tw-px-[15px]">
            <div class="ap-summary-head">
              <div class="ap-summary-head-text">
                <span class="ap-summary-eyebrow">Application Summary</span>
                <h2 class="ap-summary-title">{{ details.itemDisplayName }}</h2>
              </div>
              <span class="ap-summary-status">
                <span class="ap-status-dot"></span>
                Approved
              </span>
            </div>

            <div class="ap-summary-body">
              <div class="ap-summary-rows">
                <div class="ap-summary-row">
                  <span class="ap-summary-label">Application</span>
                  <span class="ap-summary-value ap-summary-value--accent ap-summary-value--truncate tablet:tw-max-w-full">{{ details.campaignDisplayName }}</span>
                </div>
                <div class="ap-summary-row">
                  <span class="ap-summary-label">Full Name</span>
                  <span class="ap-summary-value">{{ details.firstName }} {{ details.lastName }}</span>
                </div>
                <div class="ap-summary-row">
                  <span class="ap-summary-label">Email</span>
                  <span class="ap-summary-value ap-summary-value--truncate">{{ details.email }}</span>
                </div>
                <div class="ap-summary-row">
                  <span class="ap-summary-label">Community</span>
                  <span class="ap-summary-value ap-summary-value--truncate tablet:tw-max-w-full" [smlTooltip]="details.communityDisplayName" placement="bottom">{{ details.communityDisplayName }}</span>
                </div>
              </div>

              <div class="ap-summary-total">
                <div class="ap-summary-total-text">
                  <span class="ap-summary-total-label">Registration Fee</span>
                  <span class="ap-summary-total-meta">Charged once, securely</span>
                </div>
                <span class="ap-summary-total-amount">
                  {{ details.approvedPaymentAmount | currency:'USD':'symbol':'1.0-0' }}
                </span>
              </div>
            </div>
          </section>

          <section class="ap-methods max-md:!tw-px-[10px]">
            <h3 class="ap-methods-title">Select Payment Method</h3>

            <div class="ap-method-tiles max-md:!tw-mb-0" [class.ap-method-tiles--two]="!isGooglePayAvailable">
              <label class="ap-method-tile" [class.is-selected]="selectedPaymentMethod === 'card'">
                <input type="radio" name="ap-payment" value="card"
                  [(ngModel)]="selectedPaymentMethod"
                  (ngModelChange)="onPaymentMethodChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  class="ap-method-radio" />
                <span class="ap-method-icon ap-method-icon--card" aria-hidden="true">
                  <img src="./assets/images/survey-card.svg" alt="" />
                </span>
                <span class="ap-method-text">
                  <strong>Credit / Debit Card</strong>
                  <small>Visa, Mastercard, Amex, Discover</small>
                </span>
                <span class="ap-method-check" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </label>

              <label class="ap-method-tile" [class.is-selected]="selectedPaymentMethod === 'bank'">
                <input type="radio" name="ap-payment" value="bank"
                  [(ngModel)]="selectedPaymentMethod"
                  (ngModelChange)="onPaymentMethodChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  class="ap-method-radio" />
                <span class="ap-method-icon ap-method-icon--bank" aria-hidden="true">
                  <img src="./assets/images/survey-bank.svg" alt="" />
                </span>
                <span class="ap-method-text">
                  <strong>US Bank Account</strong>
                  <small>Direct ACH debit</small>
                </span>
                <span class="ap-method-check" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </label>

              <label *ngIf="isGooglePayAvailable" class="ap-method-tile" [class.is-selected]="selectedPaymentMethod === 'gpay'">
                <input type="radio" name="ap-payment" value="gpay"
                  [(ngModel)]="selectedPaymentMethod"
                  (ngModelChange)="onPaymentMethodChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  class="ap-method-radio" />
                <span class="ap-method-icon ap-method-icon--gpay" aria-hidden="true">
                  <img src="./assets/images/survey-gpay.svg" alt="" />
                </span>
                <span class="ap-method-text">
                  <strong>Google Pay</strong>
                  <small>Tap to pay instantly</small>
                </span>
                <span class="ap-method-check" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </label>
            </div>

            <div *ngIf="selectedPaymentMethod === 'card'" class="ap-method-panel max-md:!tw-px-0">
              <div class="ap-method-panel-head">
                <span class="ap-method-panel-label">Card information</span>
                <span class="ap-method-panel-secure">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="4" y="11" width="16" height="10" rx="2" stroke="currentColor" stroke-width="2"/>
                    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  Encrypted
                </span>
              </div>
              <div class="ap-card-element-shell max-md:!tw-px-[10px]" [class.is-loading]="!isPaymentIntentLoaded">
                <div id="ap-card-element" class="ap-card-element"></div>
                <div *ngIf="!isPaymentIntentLoaded" class="ap-card-element-skeleton">
                  <div class="ap-skel-bar ap-skel-bar--num"></div>
                  <div class="ap-skel-bar ap-skel-bar--exp"></div>
                  <div class="ap-skel-bar ap-skel-bar--cvc"></div>
                </div>
              </div>
              <div class="ap-card-brands">
                <span class="ap-card-brands-label">We accept</span>
                <span class="ap-brand ap-brand--visa">VISA</span>
                <span class="ap-brand ap-brand--mc">
                  <i class="ap-brand-mc-dot ap-brand-mc-dot--red"></i>
                  <i class="ap-brand-mc-dot ap-brand-mc-dot--yellow"></i>
                </span>
                <span class="ap-brand ap-brand--amex">AMEX</span>
                <span class="ap-brand ap-brand--disc">DISC</span>
              </div>
            </div>

            <div *ngIf="selectedPaymentMethod === 'bank'" class="ap-method-panel">
              <div class="ap-method-panel-head">
                <span class="ap-method-panel-label">Bank account details</span>
                <span class="ap-method-panel-secure">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="4" y="11" width="16" height="10" rx="2" stroke="currentColor" stroke-width="2"/>
                    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  Encrypted
                </span>
              </div>
              <div class="ap-card-element-shell" [class.is-loading]="!isPaymentIntentLoaded">
                <div id="ap-bank-account-element"></div>
                <div *ngIf="!isPaymentIntentLoaded" class="ap-card-element-skeleton">
                  <div class="ap-skel-bar ap-skel-bar--num"></div>
                  <div class="ap-skel-bar ap-skel-bar--exp"></div>
                </div>
              </div>
            </div>

            <div *ngIf="selectedPaymentMethod === 'gpay'" class="ap-method-panel">
              <div class="ap-method-panel-head">
                <span class="ap-method-panel-label">Google Pay</span>
                <span class="ap-method-panel-secure">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="4" y="11" width="16" height="10" rx="2" stroke="currentColor" stroke-width="2"/>
                    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  Tokenized
                </span>
              </div>
              <div class="ap-card-element-shell ap-card-element-shell--gpay" [class.is-loading]="!isPaymentIntentLoaded">
                <div id="ap-google-pay-button"></div>
                <div *ngIf="!isPaymentIntentLoaded" class="ap-card-element-skeleton">
                  <div class="ap-skel-bar ap-skel-bar--num"></div>
                </div>
              </div>
            </div>
          </section>

          <div class="ap-submit-wrap max-md:!tw-px-[10px]" *ngIf="selectedPaymentMethod !== 'gpay'">
            <button type="submit"
              class="ap-submit-button"
              [class.is-loading]="isShowPaymentLoader"
              [disabled]="isShowPaymentLoader"
              (click)="handleSubmit($event)">
              <span class="ap-submit-content" *ngIf="!isShowPaymentLoader">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="4" y="11" width="16" height="10" rx="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>Pay Now</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="ap-submit-arrow">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="ap-submit-content" *ngIf="isShowPaymentLoader">
                <span class="ap-submit-spinner" aria-hidden="true"></span>
                <span>Processing your payment...</span>
              </span>
              <span class="ap-submit-shine" aria-hidden="true"></span>
            </button>
          </div>

          <footer class="ap-trust-footer">
            <div class="ap-trust-poweredby">
              Powered by
             <i-icon name="see-my-legacy" class="tw-h-[30px] tw-w-[130px]"></i-icon>
            </div>
          </footer>
        </div>
      </ng-container>
    </div>
</div>
